/** Hardcoded platform admins (v1). Compare case-insensitively. */
export const ADMIN_EMAILS = [
  "info@ardeanlanguages.com",
  "edanur.gega@ardeanlanguages.com",
];

export function normalizeEmail(email) {
  return (email || "").trim().toLowerCase();
}

export function isAdminEmail(email) {
  const normalized = normalizeEmail(email);
  return ADMIN_EMAILS.some((admin) => admin === normalized);
}

export function teacherStudentLinkId(teacherId, studentId) {
  return `${teacherId}_${studentId}`;
}
